export type AtVirtualClinicAdmissionType1 =
  'A' | 'G' | 'K' | 'T' | 'W' | 'R' | 'P' | 'L' | 1 | 2 | 3 | 4 | 5 | 6 | 9;

export const AT_VIRTUAL_CLINIC_ADMISSION_TYPE_1_DISPLAY_NAMES: { [admissionType1 in AtVirtualClinicAdmissionType1]: string } = {
  A: 'Aufnahme in den allgemein stationären Bereich inkl. Aufnahme auf Intensiveinheiten',
  G: 'Aufnahme eines Frühgeborenen/Neugeborenen am Tag der Geburt oder am Folgetag in den allgemein stationären Bereich inkl. Aufnahme auf Intensiveinheiten',
  K: 'Aufnahme eines 0-Tagesfalls',
  T: 'Transfer von einem anderen Krankenhaus in den allgemein stationären Bereich inkl. Intensiveinheiten',
  W: 'Wiederaufnahme in den allgemein stationären Bereich inkl. Wiederaufnahme auf Intensiveinheiten',
  R: 'Aufnahme in den Bereich der Rehabilitation',
  P: 'Aufnahme in den ausschließlichen Bereich der Pflege',
  L: 'Kennzeichen der Datensätze, die den Patientenaufenthalt nach dem Zeitpunkt der Asylierung beschreiben',
  1: 'Fremdzuweisung von einem:einer Allgemeinmediziner:in',
  2: 'Fremdzuweisung von einem Facharzt/einer Fachärztin',
  3: 'Fremdzuweisung von der eigenen/einer anderen Krankenanstalt ohne bestehenden stationären Aufenthalt',
  4: 'Fremdzuweisung von einem Notarzt/einer Notärztin',
  5: 'Selbstzuweisung (ohne Einweisungsschein)',
  6: 'Wiederbestellung',
  9: 'Sonstige Zuweisung (durch Behörde, Pflegeeinrichtung, etc.)',
};
